import React, {useEffect, useState} from "react";

function ContractLengthChooser(props) {

    const transformContractLengths = () => {
        return props.items.map(length => ({
            value: length,
            active: props.defaultLength === length
        }));
    }

    const [contractLengths, setContractLengths] = useState(transformContractLengths());

    const updateContractLengths = (newLength) => {
        setContractLengths([...contractLengths].map(length => ({
            value: length.value,
            active: newLength === length.value
        })));
    }

    useEffect(() => {
        setContractLengths(transformContractLengths());
    }, [props.items]);

    const lengthButtonClickHandler = (chosenLength) => {
        updateContractLengths(chosenLength.value);
        props.onChange(chosenLength.value);
    };

    let lengthButtons = contractLengths.map(contractLength => (
        <button key={contractLength.value}
                type="button"
                onClick={() => lengthButtonClickHandler(contractLength)}
                className={"calc__period-btn" + (contractLength.active ? " calc__period-btn--active" : "")}>
            {contractLength.value}
        </button>
    ));

    const labelStr = typeof props.label === 'string' ? props.label : '';
    const parenIdx = labelStr.indexOf('(');
    const title    = parenIdx >= 0 ? labelStr.slice(0, parenIdx).trim() : labelStr;
    const subtitle = parenIdx >= 0 ? labelStr.slice(parenIdx) : null;

    return (
        <div className="calc__form-item">
            <div className="calc__period-header">
                <span className="calc__period-title">{title}</span>
                {subtitle && <span className="calc__period-subtitle">{subtitle}</span>}
            </div>
            <div className="calc__period-row">
                {lengthButtons}
            </div>
        </div>
    );
}

export default ContractLengthChooser;
